import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
interface HeaderProps {
  isMenuOpen: boolean;
  onToggleMenu: () => void;
}
export function Header({
  isMenuOpen,
  onToggleMenu
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Header background logic
  const headerBgClass = isScrolled || isMenuOpen ? 'bg-white shadow-sm' : 'bg-transparent';
  // Text color logic
  const textColorClass = isScrolled || isMenuOpen ? 'text-charcoal' : 'text-white';
  // Hamburger line color logic
  const hamburgerLineColor = isScrolled || isMenuOpen ? 'bg-charcoal' : 'bg-white';
  return <header className={`fixed top-0 left-0 w-full h-[80px] z-50 transition-all duration-300 ${headerBgClass}`} data-id="element-105">
      <div className="h-full w-full px-8 flex items-center justify-between" data-id="element-106">
        {/* Left - Empty for balance */}
        <div className="w-[40px] hidden md:block" data-id="element-107"></div>

        {/* Center - Logo */}
        <div className={`font-optima font-semibold text-[28px] tracking-[0.15em] uppercase transition-colors duration-300 ${textColorClass}`} data-id="element-108">
          Glenlofty
        </div>

        {/* Right - Hamburger */}
        <button onClick={onToggleMenu} className="group w-[40px] h-[40px] flex items-center justify-center focus:outline-none" aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-109">
          {isMenuOpen ? <X className={`w-8 h-8 transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-charcoal'} group-hover:text-gold`} data-id="element-110" /> : <div className="flex flex-col gap-[6px] items-end" data-id="element-111">
              <span className={`block w-[28px] h-[2px] transition-colors duration-300 ${hamburgerLineColor} group-hover:bg-gold`} data-id="element-112"></span>
              <span className={`block w-[28px] h-[2px] transition-colors duration-300 ${hamburgerLineColor} group-hover:bg-gold`} data-id="element-113"></span>
              <span className={`block w-[28px] h-[2px] transition-colors duration-300 ${hamburgerLineColor} group-hover:bg-gold`} data-id="element-114"></span>
            </div>}
        </button>
      </div>
    </header>;
}